import React from "react";

import { ErrorMessage, PrimaryButton, SecondaryButton } from "widgets";
import Loader from "Shared/Loader/Loader";

import styles from "./ConfirmSchedule.module.scss";

const ConfirmSchedule = (props) => {
  const { onCancel, onConfirm, isPending, error ,isError,parts} = props;

  return (
    <div className={styles.popOverContainer}>
      <div className={styles.text}>Are you sure you want to confirm {parts} parts schedule for payment ?</div>
      <div className={styles.flexContainer}>
        <SecondaryButton onClick={onCancel}>Go Back</SecondaryButton>
        <PrimaryButton onClick={onConfirm}>
          {isPending ? <Loader /> : "Confirm and Proceed"}
        </PrimaryButton>
      </div>
      {isError ? (
        <ErrorMessage>{error.message}</ErrorMessage>
      ) : null}
    </div>
  );
};
export default ConfirmSchedule;
